import { Button } from 'antd';
import { UserLoginButtons } from 'client/components/auth/login/UserLoginButtons';
import { SecondaryText } from 'client/ui/display/text/SecondaryText';
import { IRequestStateDto } from 'common/dto/RequestStateDto';
import { ICitizen } from 'common/schema/Citizen';
import { IProcedure } from 'common/schema/Procedure';
import * as React from 'react';
import { Link } from 'react-router-dom';

export interface IProcedureViewSummaryActionsProps {
  isSendable: boolean;
  procedure: IProcedure;
  citizen?: ICitizen | null;
  requestState?: IRequestStateDto;
}

/**
 * Azioni disponibili a partire dalla scheda della domanda.
 */
export function ProcedureViewSummaryActions(
  props: IProcedureViewSummaryActionsProps
) {
  const { isSendable, procedure, citizen, requestState } = props;

  // Se il pulsante è nascosto per definizione, lo nascondiamo
  if (procedure.compileButtonHidden) {
    return null;
  }

  // Se la domanda non è inviabile (le date non lo permettono) lo evidenziamo
  if (!isSendable) {
    return (
      <SecondaryText>Non è possibile compilare questa istanza.</SecondaryText>
    );
  }

  // Se la domanda richiede il login e l'utente non è loggato, mostriamo i pulsanti
  // e gli chiediamo di effettuare l'accesso
  if (procedure.requiresAuth === true && !citizen) {
    return (
      <>
        <SecondaryText>
          Per la compilazione dall'istanza è necessario effettuare l'accesso.
        </SecondaryText>
        <UserLoginButtons />
      </>
    );
  }

  // Se è già stata inviata una domanda, e la domanda è configurata come
  // "unica", lo segnaliamo.
  if (!requestState?.canSend) {
    return (
      <Link to={`/richieste/${requestState?.requestId}/dettaglio`}>
        Hai già presentato questa istanza.
      </Link>
    );
  }

  if (!procedure.isCurrentUserEnabled) {
    return (
      <Button block size="large" type="primary" disabled>
        Vai alla Compilazione
      </Button>
    );
  }

  // Altrimenti mostriamo il link
  return (
    <Link to={`/domande/${procedure.id}/modulo`}>
      <Button block size="large" type="primary">
        Vai alla Compilazione
      </Button>
    </Link>
  );
}
